<template>
    <Layout class="layout">
        <Headers></Headers>
        <Layout>
            <Sider hide-trigger :style="{height:($store.state.tableHight - 65) + 'px'}" class="rx-sider">
                <Side></Side>
            </Sider>
            <Layout class="zc-main">
                <Content class="zc-body" :style="{height:($store.state.tableHight - 105) + 'px'}">
                    <Card :bordered="false" :dis-hover="true">
                        <div slot="title" class="text-primary"><Icon type="md-stats" size="16"  /> 订单统计</div>
                        <Row :gutter="16" >
                            <Col span="6">
                                <div class="rx-index-box">
                                    <div class="box-line">
                                        <div class="order-count text-primary">
                                            {{ basic.orderCount || 0 }}
                                        </div>
                                    </div>
                                    <div class="name">订单总量</div>
                                    <Icon type="ios-cafe" size="26" class="icons" />
                                </div>
                            </Col>
                            <Col span="6">
                                <div class="rx-index-box">
                                    <div class="box-line">
                                        <div class="order-count text-primary">
                                            {{ basic.orderSettleCount || 0 }}
                                        </div>
                                    </div>
                                    <div class="name">待结算订单</div>
                                    <Icon type="md-contacts" size="26" class="icons" />
                                </div>
                            </Col>
                            <Col span="6">
                                <div class="rx-index-box">
                                    <div class="box-line">
                                        <div class="order-count text-primary">
                                            {{ basic.orderPayCount || 0 }}
                                        </div>
                                    </div>
                                    <div class="name">客户待收款</div>
                                    <Icon type="ios-photos" size="26" class="icons" />
                                </div>
                            </Col>
                            <Col span="6">
                                <div class="rx-index-box">
                                    <div class="box-line">
                                        <div class="order-count text-primary">
                                            {{ basic.orderDriverPayCount || 0 }}
                                        </div>
                                    </div>
                                    <div class="name">司机待付款</div>
                                    <Icon type="ios-rose" size="26" class="icons" />
                                </div>
                            </Col>
                        </Row>
                    </Card>

                    <Card :bordered="false" :dis-hover="true">
                        <div slot="title" class="text-primary"><Icon type="md-stats" size="16"  /> 会务订单统计</div>
                        <Row :gutter="16" >
                            <Col span="6">
                                <div class="rx-index-box">
                                    <div class="box-line">
                                        <div class="order-count text-primary">
                                            {{ basic.meetingCount || 0 }}
                                        </div>
                                    </div>
                                    <div class="name">会务订单总量</div>
                                    <Icon type="ios-cafe" size="26" class="icons" />
                                </div>
                            </Col>
                            <Col span="6">
                                <div class="rx-index-box">
                                    <div class="box-line">
                                        <div class="order-count text-primary">
                                            {{ basic.meetingSettleCount || 0 }}
                                        </div>
                                    </div>
                                    <div class="name">会务待结算订单</div>
                                    <Icon type="md-contacts" size="26" class="icons" />
                                </div>
                            </Col>
                            <Col span="6">
                                <div class="rx-index-box">
                                    <div class="box-line">
                                        <div class="order-count text-primary">
                                            {{ basic.meetingExamineCount || 0 }}
                                        </div>
                                    </div>
                                    <div class="name">会务待审批订单</div>
                                    <Icon type="ios-photos" size="26" class="icons" />
                                </div>
                            </Col>
                            <Col span="6">
                                <div class="rx-index-box">
                                    <div class="box-line">
                                        <div class="order-count text-primary">
                                            {{ basic.meetingInvoCount || 0 }}
                                        </div>
                                    </div>
                                    <div class="name">会务待开票订单</div>
                                    <Icon type="ios-rose" size="26" class="icons" />
                                </div>
                            </Col>
                        </Row>
                    </Card>
                    
                    <Row>
                        <Col span="24">
                            <Card :bordered="false" class="rx-index-card" >
                                <div slot="title" class="text-primary"><Icon type="md-stats" size="16"  /> 近15日订单统计</div>
                                <span slot="extra">
                                   <Icon type="md-calendar" /> {{ basic.dateRange }}
                                </span>
                                <div ref="orderChart" class="rx-chart"></div>
                            </Card>
                        </Col>
                    </Row>

                    <Row>
                        <Col span="24">
                            <Card :bordered="false" class="rx-index-card" >
                                <div slot="title" class="text-primary"><Icon type="md-stats" size="16"  /> 近15日会务订单统计</div>
                                <span slot="extra">
                                   <Icon type="md-calendar" /> {{ basic.dateRange }}
                                </span>
                                <div ref="meetingChart" class="rx-chart"></div>
                            </Card>
                        </Col>
                    </Row>
                </Content>
            </Layout>
        </Layout>
    </Layout>
</template>

<script>
import '@/assets/admin/style.css'
import Headers from "@/components/public/Headers";
import Side from "@/components/public/Side";
import echarts from 'echarts'

export default {
  name: 'HomeIndex',
    components: {
        Headers, Side
    },
  data () {
    return {
        isCollapsed: false,
        basic: [],
        orderChart: null,
        meetingChart: null,
    }
  },
    created(){
        this.getStatic();
    },
    mounted(){
        let that = this;
        that.HeightInit();
        window.addEventListener('resize' , that.chartResize);
    },
    beforeDestroy(){
        window.removeEventListener('resize' , this.chartResize);
        if(this.orderChart){ this.orderChart.dispose(); this.orderChart = null; }
        if(this.meetingChart){ this.meetingChart.dispose(); this.meetingChart = null; }
    },
    computed: {
        rotateIcon () {
            return [
                'menu-icon',
                this.isCollapsed ? 'rotate-icon' : ''
            ];
        },
        menuitemClasses () {
            return [
                'menu-item',
                this.isCollapsed ? 'collapsed-menu' : ''
            ]
        }
    },
    methods: {
        getStatic(){
            let that = this;
            that.$axios.get('/admin/index/getStatic')
                .then(function (e) {
                    if(e.code ==0) {
                        that.basic = e.data;
                        that.initChart();
                    }else{
                        that.$Message.error({ background: true,duration:3, content:e.msg});
                    }
                })
                .catch(function (e) {
                    that.$Message.error({ background: true,duration:3, content:'请求发送失败'});
                });
        },
        initChart(){
            let that = this;
            that.orderChart = echarts.init(that.$refs.orderChart);
            that.orderChart.setOption(that.getChartOption(that.basic.orderDays || [] , '订单量'));
            that.meetingChart = echarts.init(that.$refs.meetingChart);
            that.meetingChart.setOption(that.getChartOption(that.basic.meetingDays || [] , '会务订单量'));
        },
        getChartOption(list , name){
            let days = list.map(function (item) { return item.day ? item.day.substr(5) : ''; });
            let counts = list.map(function (item) { return item.count || 0; });
            return {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { type: 'shadow' }
                },
                grid: { left: 40, right: 30, top: 40, bottom: 30 },
                xAxis: {
                    type: 'category',
                    data: days,
                    axisLabel: { interval: 0, rotate: 40 }
                },
                yAxis: {
                    type: 'value',
                    minInterval: 1
                },
                series: [{
                    name: name,
                    type: 'bar',
                    barMaxWidth: 30,
                    itemStyle: { color: '#2d8cf0' },
                    label: { show: true, position: 'top' },
                    data: counts
                }]
            };
        },
        chartResize(){
            if(this.orderChart) this.orderChart.resize();
            if(this.meetingChart) this.meetingChart.resize();
        },
        collapsedSider () {
            this.$refs.side1.toggleCollapse();
        },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            // 动态计算 table 的高度重新赋值
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
    .rx-index-box {
        width: 100%;
        position: relative;
        border: 1px solid #f6f6f6;
        background: #f6f6f6;
        border-radius: 5px;
        padding: 25px 10px;
        position: relative;
        box-shadow: 5px 5px 10px #EEE;
        cursor: pointer;
        .name {
            width: 100%;
            font-size: 15px;
            //font-weight: bold;
        }
        .box-line {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-bottom: 15px;
            .order-count {
                font-size: 20px;
                font-weight: bold;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .order-count-small {
                font-size: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                em {
                    font-size: 16px;
                    padding-left: 10px;
                }
            }
        }
        .icons {
            position: absolute;
            bottom: 10px;
            right: 10px;
            color: rgba(40,130,255,0.1);
        }
    }
    .rx-index-card {
        margin-top: 20px;
    }
    .rx-chart {
        width: 100%;
        height: 320px;
    }
</style>



// WEBPACK FOOTER //
// src/view/home/Index.vue